/**
* 课程详情
*/
<template>
    <div  class="box-style">
        <van-nav-bar placeholder title="课程详情" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>

      <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: 100vh">
        <div class="yj-box">
          <div class="box-title">
            <h2>课程信息</h2>
            <!--<img src="~@/assets/xl.png">-->
          </div>
          <div class="yj-con">
            <div class="con-list"><span>机构名称：</span><p>{{ record.institutionName }}</p></div>
            <div class="con-list"><span>课程名称：</span><p>{{ record.curriculumName }}</p></div>
            <div class="con-list"><span>课时：</span><p>{{ record.classHour }}</p></div>
            <div class="con-list"><span>报名价格：</span><p>{{ record.price }}</p></div>
            <div class="con-list"><span>任课教师：</span><p>{{ record.teacherName }}</p></div>
            <div class="con-list"><span>上课时间：</span><p>{{ record.classTime }}</p></div>
            <div class="con-list"><span>上课地点：</span><p>{{ record.address }}</p></div>
            <div class="con-list"><span>名额：</span><p>{{ record.planCount }}</p></div>
            <div class="con-list"><span>开班日期：</span><p>{{ record.startDate }}</p></div>
            <div class="con-list"><span>图片：</span><p><custom-upload ref="picUrls" :showUpload="false" :value="record.pic"/></p></div>
            <div class="con-list"><span>简介：</span><p>{{ record.introduction }}</p></div>
            <div class="con-list"><span>报名人数：</span><p>{{ record.realCount }}</p></div>
          </div>
        </div>
        <div  class="yj-box">
          <div  class="box-title">
            <h2>学员列表</h2>
            <!--<img src="~@/assets/xl.png">-->
          </div>
          <div class="yj-con" v-for="item in applyInfoList" :key="item.id">
            <div class="xk-list" >
              <div class="xk-box-top"><b>{{ item.studentName }}</b> <b>{{ item.phone }}</b></div>
              <div class="xk-box-bottom">
                <span v-show="item.classHour">共: {{ item.classHour }}课时 </span>
                <span v-show="item.leftHour">剩余: {{ item.leftHour }}课时</span>
              </div>
            </div>
          </div>
        </div>
        <div style="height:90px"></div>
        <van-button class="floatbox"  v-if="applyInfoList.length > 0" round type="primary" @click="toSignCourse">销课</van-button>
      </van-pull-refresh>

    </div>
</template>

<script>

    import {queryDetailInfo} from '@/api/course/institutionCourse'
    import {filterLabelName} from '@/api/common'
    import customUpload from '@/components/customUpload'

    export default {
        name: 'DisputeDetail',
        components: {customUpload},
        data () {
            return {
                loading: false,
                filterLabelName,
                id: '',
                record: {},
                applyInfoList: []
            }
        },
        computed: {
        },
        created () {
            this.id = this.$route.query.id;
            this.refresh()
        },
        mounted () {
        },
        methods: {
          toSignCourse(){
            //销课
            this.$router.push({path: `/institutionCourse/sign?id=${this.id}`});
          },
          getDict(){
          },
          refresh() {
              this.getDict();
              this.getDetail()
          },
          onClickLeft() {
              this.$router.go(-1)
          },
          getDetail() {
            queryDetailInfo({ curriculumId: this.id }).then(res => {
                  if (res.code === 10000) {
                    this.record = res.result || {};
                    this.applyInfoList = this.record.applyInfoList || []
                  }
              }).finally(() => {
                  setTimeout(() => {
                      this.loading = false
                  }, 100)
              })
          },
        }
    }
</script>

<style scoped>
.yj-box{
  display: flex;
  margin: 0 10px;
  flex-direction: column;
}
.box-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height:16px;
  margin-top: 23px;
  margin-bottom: 17px;
}
.box-title h2{
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.box-title img{
  width: 16px;
  height: 9px;
}
.yj-con{
  background: #F4F5F7;
  border-radius:12px;
  display: flex;
  padding: 17px;
  flex-direction: column;
  margin-bottom: 10px;
}
.con-list{
  display: flex;
  margin-bottom: 15px;
}
.con-list:last-child{
  margin-bottom: 0;
}
.con-list span{
  display: flex;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width:75px;
  justify-content: flex-end;
  padding-right: 5px;
}
.con-list p{
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/deep/.van-uploader__preview-image{
  height: 15vw;
  width:73px;
}
.box-style{
  padding-bottom: 20px;
}

.box-style{
  padding-bottom: 20px;
}
.xk-list{
  display: flex;
  flex-direction: column;
}
.xk-box{
  margin-bottom: 10px;
}
.xk-box-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom:15px;
}
.xk-box-bottom{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xk-box-bottom span{
  font-size:14px;
}
.xk-box-top b{
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.xk-box-bottom i{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding:4px 6px;
  border-radius:12px;
  background: #FF9900;
}
</style>
